import React, { useEffect } from 'react';
import { useMatch, useNavigate, useSearchParams } from 'react-router';

import { appPaths } from '~/routes/app-paths';
import { queryKeys } from '~/routes/query-params';
import { useWatchlistManagerWidget } from '~/stores/use-watchlist-manager-widget/useWatchlistManagerWidget';
import { WatchlistManagerWidget } from '~/widgets/watchlist-manager-widget/WatchlistManagerWidget';

import * as S from './WatchlistManagerModal.styles';

export const WatchlistManagerModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const isOnWatchlistRoute = useMatch(`${appPaths.watchlist}/*`);

  const { setIsAddMode, setOnConfirmCallback, setShouldResetList } =
    useWatchlistManagerWidget(state => ({
      setIsAddMode: state.setIsAddMode,
      setOnConfirmCallback: state.setOnConfirmCallback,
      setShouldResetList: state.setShouldResetList,
    }));

  const onClose = () => {
    searchParams.delete(queryKeys.widget);
    setSearchParams(searchParams);
  };

  const onListCreated = (id: string) => {
    if (isOnWatchlistRoute) {
      navigate(`${appPaths.watchlist}/${id}`);
    } else {
      onClose();
    }
  };

  useEffect(() => {
    return () => {
      setIsAddMode();
      setOnConfirmCallback();
      setShouldResetList();
    };
  }, []);

  return (
    <S.StyledModal
      data-testid="watchlist-manager-modal"
      isOpen
      onClose={onClose}
    >
      <WatchlistManagerWidget
        onListCreated={onListCreated}
        onCancel={onClose}
      />
    </S.StyledModal>
  );
};
